import React from 'react';
import PropTypes from 'prop-types';

import './CipresBlock.scss';
import logo from './login-logo.png';

const CipresBlock = ({ returnToken, returnUrl, returnLabel }) => (
  <div className="cipres-block">
    <div className="logo">
      <img src={logo} alt="Logo" />
    </div>
    <a className="link" href={`${returnUrl}${returnToken}`}>
      <code>{returnLabel}</code>
    </a>
  </div>
);

CipresBlock.propTypes = {
  returnUrl: PropTypes.string,
  returnToken: PropTypes.string,
  returnLabel: PropTypes.string
};

CipresBlock.defaultProps = {
  returnUrl: 'https://espacecourtier.cipres.fr',
  returnToken: '',
  returnLabel: "Retour vers l'extranet Courtier"
};

export default CipresBlock;
